import useSWR from "swr";
import { send, setSessionToken } from "./api";

export interface CurrentUser {
  id: string;
  email: string;
  name: string | null;
  picture: string | null;
  isAdmin: boolean;
  // Аккаунт разработчика (DEVELOPER_EMAILS): dev-страница «Использование».
  // Опционален: старый /me до деплоя флага — считаем «не разработчик».
  isDeveloper?: boolean;
  pages: string[];
  roleName: string | null;
}

export function useCurrentUser() {
  const { data, error, isLoading, mutate } = useSWR<CurrentUser>(
    "/api/auth/regs/me", { revalidateOnFocus: false, shouldRetryOnError: false },
  );
  return { user: data, isLoading, error, mutate };
}

export async function logout(): Promise<void> {
  await send("/api/auth/regs/logout", "POST").catch(() => {});
  setSessionToken(null);
  window.location.href = `${import.meta.env.BASE_URL.replace(/\/$/, "")}/login`;
}
